export default "__VITE_ASSET__BzLYPQSB__"